import styled from 'styled-components';

export const FooterWrapper = styled.footer`
  background-color: #00624f;
  display: flex;
  justify-content: center;
  padding: 24px 16px;
  @media (min-width: 768px) {
    padding: 32px;
  }
`;
export const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
  @media (min-width: 1025px) {
    max-width: 880px;
  }
`;
export const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  @media (min-width: 768px) {
    flex-direction: row;
  }
`;
export const LogoBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  p {
    white-space: pre-line;
    color: #ffffff;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%; /* 22.4px */
    letter-spacing: 0.15px;
    margin: 0;
  }

  img {
    width: auto;
    height: 32px;
  }

  @media (min-width: 768px) {
    max-width: 100%;
    p {
      white-space: nowrap;
    }
    img {
      width: 131px;
      height: 40px;
    }
  }
`;
export const LogoText = styled.div`
  white-space: pre-line;
  color: #ffffff;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 22.4px */
  letter-spacing: 0.15px;
  @media (min-width: 768px) {
      white-space: nowrap;
  `;
export const Subtitle1 = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 22.4px */
  letter-spacing: 0.15px;
`;
export const ContactBlock = styled.div`
  > div:nth-child(2) {
    margin-bottom: 24px;
  }
  a {
    color: #ffffff;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.5px;
    margin: 0;
    display: block;
  }
`;
export const FooterItemsTitle = styled.div`
  margin: 0 0 16px 0;
  text-transform: uppercase;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.4);
  font-size: 12px;
  letter-spacing: 1.5px;
  line-height: 116%;
`;
export const FooterItemsBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
`;
export const FooterItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #ffffff;
  min-width: 126px;
  font-size: 16px;
  a:hover {
    color: #ffe77c;
    cursor: pointer;
    text-decoration: none;
  }
`;
export const MediaBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  gap: 40px;
  height: 44px;
  padding-left: 8px;
  img {
    width: 28px;
    height: 28px;
  }

  a {
    display: contents;
  }
`;

export const MediaItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BackgroundCircle = styled.div`
  position: absolute;
  background-color: #ffffff;
  opacity: 0.1;
  border-radius: 50%;
  width: 44px;
  height: 44px;
`;
export const LicenseBlock = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 40px;
  @media (min-width: 768px) {
    flex-direction: row;
    align-items: flex-end;
    > div {
      width: 100%;
    }
  }
  @media (min-width: 1025px) {
    justify-content: space-between;
    > div {
      width: auto;
    }
  }
  img {
    width: 169px;
  }
`;
export const FooterLinkBlock = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 32px;
  color: #ffffff;
  opacity: 0.5;
  @media (min-width: 768px) {
    gap: 24px;
  }
  @media (min-width: 1025px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
  }
`;
export const PolicyLinks = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%; /* 14px */
  letter-spacing: 0.25px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

export const FooterLink = styled.div`
  font-family: DM-Mono, monospace;
  font-size: 8px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 10.4px */
  letter-spacing: 0.4px;
`;

export const StyledSVG = styled.svg`
  z-index: 1;
  width: 28px;
  height: 28px;
  fill: #ffffff;
  transition: fill 0.3s;

  &:hover,
  &:active {
    fill: #ffe77c;
  }
`;

export const WhatsAppContact = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @media (min-width: 768px) {
    flex-direction: row;
  }
  & > div {
    gap: 0.5rem;
  }
`;

export const WhatsAppNumber = styled.p`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: 0.5px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0;
  & svg {
    padding: 0;
    background: none;
    margin-right: 0.5rem;
    cursor: pointer;
  }
  & a {
    display: flex;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${(props) => props.gap || '40px'};
`;
